import { observer } from 'mobx-react-lite';
import { AttachmentFullViewState } from 'owa-attachment-full-data';
import { AttachmentModel } from 'owa-attachment-model-store';
import { AttachmentIconView } from 'owa-attachment-view';
import { ClientItemId } from 'owa-client-ids';
import { AttachmentPreviewMode } from 'owa-sxs-store';
import * as React from 'react';
import AttachmentActionsContainer from './AttachmentActionsContainer';
import AttachmentInfoView from './AttachmentInfoView';

export interface AttachmentDocProps {
    attachmentViewState: AttachmentFullViewState;
    attachment: AttachmentModel;
    onDeleteButtonClicked: (attachmentViewState: AttachmentFullViewState) => void;
    previewState: AttachmentPreviewMode;
    isActionsContainerVisible: boolean;
    parentItemId: ClientItemId;
}

const styles = require('./AttachmentDocView.scss');

// This component is responsible for showing the attachment doc view.
export default observer(function AttachmentDocView(props: AttachmentDocProps) {
    return (
        <>
            <AttachmentIconView
                attachmentId={props.attachmentViewState.attachmentId}
                useCloudIcon={true}
            />
            <div className={styles.attachmentInfoContainer}>
                <AttachmentInfoView
                    attachmentViewState={props.attachmentViewState}
                    attachment={props.attachment}
                    isForImageView={false}
                    isActionsContainerVisible={props.isActionsContainerVisible}
                    previewState={props.previewState}
                />
            </div>
            {props.isActionsContainerVisible && (
                <AttachmentActionsContainer
                    attachmentViewState={props.attachmentViewState}
                    onDeleteButtonClicked={props.onDeleteButtonClicked}
                    isForImageView={false}
                    previewState={props.previewState}
                    attachmentClass={props.attachment.attachmentClass}
                    parentItemId={props.parentItemId}
                />
            )}
        </>
    );
});
